import en from './en';  // English
import au from './au';  // English (Australia)
import ru from './ru';  // Russian
import zh from './zh';  // Chinese (Simplified)
import ch from './ch';  // Chinese (Traditional)
import nl from './nl';  // Dutch
import gb from './gb';  // English (United Kingdom)
import ja from './ja';  // Japanese
import de from './de';  // German

const messages = {
    ...en,
    ...au,
    ...ru,
    ...zh,
    ...ch,
    ...nl,
    ...gb,
    ...ja,
    ...de,
};

export default messages;
